import React from "react";
import { FormControlLabel, Checkbox, FormGroup, FormHelperText } from "@mui/material";
import { RadioButtonUnchecked, RadioButtonChecked, CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { Controller } from "react-hook-form";

// import { Container } from './styles';

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control: any;
    error: any;
    type?: number;
    onClick?: any;
}

const CheckboxComponent: React.FC<IFormInput> = ({ id, name, label, type, control, error, onClick }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                {...field}
                                id={id}
                                icon={type === 1 ? <RadioButtonUnchecked /> : <CheckBoxOutlineBlank />}
                                checkedIcon={type === 1 ? <RadioButtonChecked /> : <CheckBox />}
                                checked={field["value"] ?? false}
                                onClick={onClick}
                            />
                        }
                        label={label}
                    />
                    <FormHelperText>{!!error && error[name]?.message}</FormHelperText>
                </FormGroup>
            )}
        />
    );
};

export default CheckboxComponent;
